var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

const SvgLiSent = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 18,
    viewBox: "0 0 20 18",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.9814 7.13219V5.52839C17.9814 3.9433 17.9814 3.15076 17.673 2.54534C17.4016 2.01279 16.9686 1.57982 16.4361 1.30848C15.8307 1 15.0381 1 13.4531 1H5.52839C3.9433 1 3.15076 1 2.54534 1.30848C2.01279 1.57982 1.57982 2.01279 1.30848 2.54534C1 3.15076 1 3.9433 1 5.52838C1 7.11347 1 9.96243 1 9.96243C-nan -nan -nan -nan -nan -nanC-nan -nan -nan -nan -nan -nanC-nan -nan -nan -nan 1 9.96243C1 10.8398 1 11.2785 1.09644 11.6384C1.35814 12.6151 2.12103 13.3779 3.09772 13.6396C3.45763 13.7361 3.89631 13.7361 4.77365 13.7361V15.9394C4.77365 16.4421 4.77365 16.6935 4.8767 16.8226C4.96632 16.9348 5.10222 17.0002 5.24587 17C5.41105 16.9998 5.60732 16.8428 5.99986 16.5288L8.25033 14.7284C8.71006 14.3606 8.93993 14.1767 9.19589 14.0459C9.42298 13.9299 9.66471 13.8451 9.91452 13.7939C10.1961 13.7361 10.4905 13.7361 11.0792 13.7361H11.8493M4.77365 5.71707C4.77365 5.71707 7.64859 5.71707 9.49072 5.71707M4.77365 9.01902H12.321M13.5 11.5L15.1512 13.2644L19 9.5",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgLiSent, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/liSent.488adcbf.svg";
export { ForwardRef as ReactComponent };